import React, { useState, useEffect } from "react";
import "./SubHeader.css";
import { useHistory, Link } from "react-router-dom";

import SearchFiles from "./SearchFiles";

// Other Imports:
import { auth } from "../User/include/Authorize";
import { useStateValue } from "../../utils/Provider/StateProvider";
import RelativeHintAdditionModal from "../../components/ModalComponent/RelativeHintAdditionModal";

function SubHeader() {
  const history = useHistory();
  const [{ user, notify }, dispatch] = useStateValue();
  const [searchText, setSearchText] = useState("");
  const [toggleNotification, setToggleNotification] = useState(false);

  const [openRelativeMapModal, setOpenRelativeMapModal] = useState(false);

  notify && notify.sort((a, b) => b.date - a.date);

  const getMonthByName = (i) => {
    var month = parseInt(i);
    switch (month) {
      case 1:
        month = "Jan";
        break;

      case 2:
        month = "Feb";
        console.log(month);
        break;

      case 3:
        month = "Mar";
        break;

      case 4:
        month = "Apr";
        break;

      case 5:
        month = "May";
        break;

      case 6:
        month = "Jun";
        break;

      case 7:
        month = "Jul";
        break;

      case 8:
        month = "Aug";
        break;

      case 9:
        month = "Sept";
        break;

      case 10:
        month = "Oct";
        break;

      case 11:
        month = "Nov";
        break;

      case 12:
        month = "Dec";
        break;

      default:
        month = "NaN";
    }

    return month;
  };
  const getDate = (i) => {
    var today, month, date;

    if (i) {
      today = i;
      var datesplit = i.split("-");

      month = getMonthByName(datesplit[1]);
      date = datesplit[2] + " " + month + " ," + datesplit[0];
    } else {
      today = new Date();
      month = getMonthByName(today.getMonth() + 1);
      date = today.getDate() + " " + month + " ," + today.getFullYear();
    }

    return date;
  };

  const notificationReaded = (id, desc) => {
    dispatch({
      type: "SET_NOTIFICATION",
      notify: notify.filter((obj) => obj.desc !== desc),
    });
  };

  const getNotification = (i) => {
    const notify = i;
    if (notify > 0 && notify < 10) {
      return "0" + notify;
    } else if (notify >= 10 && notify <= 99) {
      return notify;
    } else if (notify >= 100) {
      return "99+";
    }
  };

  // sending message to wp
  function sendMessage(message) {
    console.log("sendding ");
    const mainEl = document.querySelector("#main");
    const textareaEl = mainEl.querySelector('div[contenteditable="true"]');

    if (!textareaEl) {
      throw new Error("There is no opened conversation");
    }

    textareaEl.focus();
    document.execCommand("insertText", false, message);
    textareaEl.dispatchEvent(new Event("change", { bubbles: true }));

    setTimeout(() => {
      (
        mainEl.querySelector('[data-testid="send"]') ||
        mainEl.querySelector('[data-icon="send"]')
      ).click();
    }, 100);
  }

  return (
    <div className="subheader_container">
      <div className="subheader_container_content">
        <div className="subheader_container_content_suddenChange">
          <div className="navbar_Search_div custom_subHeaderSearch">
            {user && (
              <input
                type="text"
                className="navbar_Search"
                placeholder="search"
                value={searchText}
                onChange={(e) => {
                  setSearchText(e.target.value);
                }}
              />
            )}
            {/* <i class="fa fa-search" aria-hidden="true"></i> */}
          </div>
        </div>

        <div className="subheader_container_content_notificationIcon">
          {user && (
            <i
              class="fa fa-map"
              aria-hidden="true"
              onClick={() => setOpenRelativeMapModal(true)}
            ></i>
          )}

          {user && (
            <i
              class="fa fa-calendar"
              aria-hidden="true"
              onClick={() => history.push("/u/events")}
            ></i>
          )}

          {user && (
            <i
              class="fa fa-code-fork"
              aria-hidden="true"
              onClick={() => history.push("/tree")}
            ></i>
          )}

          <div>
            <i
              class="fa fa-bell"
              arial-hidden="true"
              onClick={() => setToggleNotification(true)}
            ></i>
            {notify ? (
              notify.length === 0 ? null : (
                <span
                  className="no_of_notification"
                  onClick={() => setToggleNotification(true)}
                >
                  {getNotification(notify.length)}
                </span>
              )
            ) : null}
          </div>
        </div>
      </div>

      {searchText ? (
        <SearchFiles text={searchText} handleClear={() => setSearchText("")} />
      ) : null}

      {toggleNotification ? (
        <div className="notication_container">
          <div className="notification_header">
            <h3>Notifications</h3>
            <i
              class="fa fa-times fa-lg"
              arial-hidden="true"
              onClick={() => setToggleNotification(false)}
            ></i>
          </div>

          {notify && (
            <div className="notification_content">
              {notify.map((i) => (
                <>
                  {!i.title.includes("(upcomming)") && (
                    <div className="notification_item">
                      <div className="notification_item_header">
                        <p className="notification_item_title">{i.title}</p>
                        <i
                          class="fa fa-times notification_item_close"
                          aria-hidden="true"
                          onClick={() => notificationReaded(i.uuid, i.desc)}
                        ></i>
                      </div>

                      <p className="notification_item_desc">
                        <div>{i.desc}</div>

                        <p> {i.date ? getDate(i.date) : getDate()}</p>
                      </p>
                    </div>
                  )}
                </>
              ))}

              <p
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  fontWeight: 500,
                  color: "#aaa",
                  padding: "10px 0px 5px 0px",
                  borderTop: "1px solid #ddd",
                  margin: "10px 5px 2px 5px",
                }}
              >
                Upcomming Birthday/Aniversary 🥳
              </p>

              {notify.map((i) => (
                <>
                  {i.title.includes("(upcomming)") && (
                    <div
                      className="notification_item"
                      onClick={() => sendMessage("hiiii")}
                    >
                      <div className="notification_item_header">
                        <p className="notification_item_title">{i.title}</p>
                        <i
                          class="fa fa-times notification_item_close"
                          aria-hidden="true"
                          onClick={() => notificationReaded(i.uuid, i.desc)}
                        ></i>
                      </div>

                      <p className="notification_item_desc">
                        <div>{i.desc}</div>

                        <p> {i.date ? getDate(i.date) : getDate()}</p>
                      </p>
                    </div>
                  )}
                </>
              ))}
            </div>
          )}

          {notify.length === 0 && (
            <div className="notification_empty_msg">
              <h5>No Notifications 🔔</h5>

              <p className="notification_empty_msg_hint">
                Notifications will only appear If you set Birthday or
                Anniversary of you closed once.
              </p>
              <br />
              <Link to="/">click here to view members</Link>
            </div>
          )}
        </div>
      ) : null}

      {openRelativeMapModal && (
        <RelativeHintAdditionModal
          title="Describe the relative category !"
          onCloseHandler={() => setOpenRelativeMapModal(false)}
        />
      )}
    </div>
  );
}

export default SubHeader;
